import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { DRUG_COVERAGE_STATUS_ENUM } from '../../../../shared/interfaces/drug-autocomplete-item.interface';
import { MedicationStateStructure } from '../../../medical-information/medication-information/reducers/medication.reducer';
import { PlanAttributes, SummaryView } from '../../interfaces/plan-attributes.interface';
import { Product } from '../../interfaces/product.interface';
import { MedicalDetailsModalComponent } from '../medical-details-modal/medical-details-modal.component';
import { IndividualDrugCoverageService } from './services/individual-drug-coverage.service';

@Component({
    selector: 'app-individual-drug-coverage',
    templateUrl: './individual-drug-coverage.component.html',
    styleUrls: ['./individual-drug-coverage.component.scss'],
    standalone: false
})
export class IndividualDrugCoverageComponent implements OnInit, OnDestroy {

  @Input() plan: Product<PlanAttributes, SummaryView>;

  numCoveredDrugs = 0;
  numTotalDrugs = 0;

  hasDrugResults = false;
  showLoadingIndicator = true;

  drugCoverageLookupSubscription: Subscription;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private drugService: IndividualDrugCoverageService,
    private matDialog: MatDialog
  ) { }

  ngOnInit() {
    const medState: MedicationStateStructure = this.reducerUtilityService.getState('MedicationInformation');
    if (!medState?.individualMedications?.length) {
      return;
    }

    this.hasDrugResults = true;

    this.drugService.triggerLookUpIfNotActive();
    this.drugCoverageLookupSubscription = this.drugService.lookupComplete$.subscribe( m => {
      if (!m) {
        return;
      }

      const medState: MedicationStateStructure = this.reducerUtilityService.getState('MedicationInformation');
      this.numTotalDrugs = medState.individualMedications.length;
      this.getCoveredDrugsAmt(m);
      
      this.showLoadingIndicator = false;
    });
  }

  ngOnDestroy() {
    if (this.drugCoverageLookupSubscription) {
      this.drugCoverageLookupSubscription.unsubscribe();
    }
  }

  getCoveredDrugsAmt(map: Map<string, Map<string, DRUG_COVERAGE_STATUS_ENUM>>) {
    let coveredAmt = 0;

    //const drugStatusByDrugId = map.get(this.drugService.getPlanIdFromProduct(this.plan));
    const drugStatusByDrugId = map.get(this.drugService.getHiosIdFromProduct(this.plan));
    const mapIter = drugStatusByDrugId.entries();
    let currentDrug = mapIter.next();

    while (!currentDrug.done) {
      const coveredStatus: DRUG_COVERAGE_STATUS_ENUM = currentDrug.value[1];
      if (coveredStatus === DRUG_COVERAGE_STATUS_ENUM.COVERED) {
        coveredAmt++;
      }
      currentDrug = mapIter.next();
    }

    this.numCoveredDrugs = coveredAmt;
  }

  showMedicalDetails() {

    this.matDialog.open(MedicalDetailsModalComponent, {
      disableClose: false,
      maxWidth: '650px',
      maxHeight: '100vh',
      data: {
        type: 'Medication',
        individualDrugCoverage: this.drugService.drugCoverageLookupResponse,
        plan: this.plan
      }
    });
  }
}
